import React from 'react';
import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/24/solid';

const StatCard = ({ 
  title, 
  value, 
  change, 
  trend, 
  icon: Icon, 
  iconColor = 'text-admin-600',
  iconBgColor = 'bg-admin-100',
  className = '' 
}) => {
  const isPositive = trend === 'up' || (change && change.startsWith('+'));
  const isNegative = trend === 'down' || (change && change.startsWith('-'));

  return (
    <div className={`bg-white rounded-xl shadow-sm p-6 border border-gray-100 ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 ${iconBgColor} rounded-lg`}>
          <Icon className={`w-6 h-6 ${iconColor}`} />
        </div>
        {change && (
          <div className={`flex items-center text-sm font-medium ${
            isPositive ? 'text-success-600' : 
            isNegative ? 'text-danger-600' : 
            'text-gray-600'
          }`}>
            {isPositive && <ArrowUpIcon className="w-4 h-4 mr-1" />}
            {isNegative && <ArrowDownIcon className="w-4 h-4 mr-1" />}
            {change}
          </div>
        )}
      </div>
      <h3 className="text-2xl font-bold text-gray-900 mb-1">{value}</h3>
      <p className="text-sm text-gray-500">{title}</p>
    </div>
  );
};

export default StatCard;
